/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Gallery_Photos_LinkInputs */

const cs_draft_gallery_photos_link = /** @type {(inputs: Draft_Gallery_Photos_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít Fotky a média`)
};

const en_draft_gallery_photos_link = /** @type {(inputs: Draft_Gallery_Photos_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Photos & Media`)
};

/**
* | output |
* | --- |
* | "Open Photos & Media" |
*
* @param {Draft_Gallery_Photos_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_gallery_photos_link = /** @type {((inputs?: Draft_Gallery_Photos_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Gallery_Photos_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_gallery_photos_link(inputs)
	return cs_draft_gallery_photos_link(inputs)
});